const convertToText = (payload) => {
  return payload.replaceAll("-", " ")
}


export default { convertToText }